module.exports = __webpack_public_path__ + "static/media/boitesTupp_02_thumb.7ca79b26.png";